import API from '@/api/index';

const account = {
  state: {
    accounts: [],
    totalAccount: 0
  },

  mutations: {
    SET_ACCOUNTS: (state, accounts) => { state.accounts = accounts },
    SET_TOTAL_ACCOUNTS: (state, totalAccount) => { state.totalAccount = totalAccount },
  },

  actions: {
    getAccounts ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getAccounts(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let accounts = result.data.data;
              commit('SET_ACCOUNTS', accounts);
              commit('SET_TOTAL_ACCOUNTS', result.data.totalRecords);
              resolve(accounts);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAccountById ({ state }, accountId) {
      return new Promise((resolve, reject) => {
        API.account
          .getAccountById(accountId)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDeviceByAccount ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getDeviceByAccount(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let devices = result.data;
              resolve(devices);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getVehicleByAccount ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getVehicleByAccount(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let vehicles = result.data;
              resolve(vehicles);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getAccountByParent ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getAccountByParent(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getSimByAccount ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getSimByAccount(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let data = result.data.data;
              resolve(data);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getUserByAccount ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getUserByAccount(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let users = result.data.data;
              resolve(users);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDistributors ({ state }) {
      return new Promise((resolve, reject) => {
        API.account
          .getDistributors()
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let distributors = result.data;
              resolve(distributors);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDealers ({ state }) {
      return new Promise((resolve, reject) => {
        API.account
          .getDealers()
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let dealers = result.data;
              resolve(dealers);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getDealerByAccount ({ state }, accountId) {
      return new Promise((resolve, reject) => {
        API.account
          .getDealerByAccount(accountId)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let dealers = result.data;
              resolve(dealers);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    checkEmail ({ state }, email) {
      return new Promise((resolve, reject) => {
        API.account
          .checkEmail(email)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    checkPhone ({ state }, phoneNumber) {
      return new Promise((resolve, reject) => {
        API.account
          .checkPhone(phoneNumber)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createAccount ({ state }, account) {
      return new Promise((resolve, reject) => {
        API.account
          .createAccount(account)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    importDealer ({ state }, accounts) {
      return new Promise((resolve, reject) => {
        API.account
          .importDealer(accounts)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateAccountToDealer ({ state }, accountId) {
      let data = {
        accountId
      };
      return new Promise((resolve, reject) => {
        API.account
          .updateAccountToDealer(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateAccountByAdmin ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.account
          .updateAccountByAdmin(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getLog ({ state }, params) {
      return new Promise((resolve, reject) => {
        API.account
          .getLog(params)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let account = result.data;
              resolve(account);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default account;


// WEBPACK FOOTER //
// ./src/store/modules/account.js